import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SERVER } from '../config/config';
import ServerImage from './ServerImage';
import { FaArrowRight } from "react-icons/fa6";


const Testimonials = () => {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${SERVER}/testimonials?limit=3`);
      // Handle both array and {items: [...]} response formats
      const data = Array.isArray(response.data) 
        ? response.data 
        : (response.data.items || []);
      setTestimonials(data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      // Fallback to static data if API fails
      setTestimonials([
        {
          id: 1,
          client_name: 'Mr Fathi',
          title: 'Fournitest founder',
          photo: '/testimonials/fathi.png',
          review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse volutpat pellentesque semper. Pellentesque et sollicitudin sapien.'
        },
        {
          id: 2,
          client_name: 'Rabeb Michkette',
          title: 'Fournitest founder',
          photo: '/testimonials/rabeb.png',
          review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse volutpat pellentesque semper. Pellentesque et sollicitudin sapien.'
        },
        {
          id: 3,
          client_name: 'Oumaima Oabi',
          title: 'Oabi Owner',
          photo: '/testimonials/fathi.png',
          review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse volutpat pellentesque semper. Pellentesque et sollicitudin sapien.'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center md:text-left mb-12">
          <h2 className="text-3xl lg:text-3xl font-bold text-gray-900 mb-6">Testimonials</h2>
          <div className="inline-flex items-center justify-center bg-[#F6F6F6] py-3 px-6 rounded-full gap-2 text-gray-600">
            <span 
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: 'var(--primary-blue)' }}
            ></span>
            <span className="text-lg font-medium">Clients that trusted us</span>
          </div>
        </div>
        <div className="flex items-center justify-center h-32">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>
      </section>
    );
  }

  if (testimonials.length === 0) {
    return (
      <section className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Testimonials</h2>
          <div className="inline-flex items-center justify-center bg-[#F6F6F6] py-3 px-6 rounded-full gap-2 text-gray-600">
            <span 
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: 'var(--primary-blue)' }}
            ></span>
            <span className="text-lg font-medium">Clients that trusted us</span>
          </div>
        </div>
        <div className="text-center text-gray-500">
          <p>No testimonials available at the moment.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-4 md:py-16 px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-12">
        <h2 className="text-2xl lg:text-5xl font-bold text-gray-900 mb-2 md:mb-6 text-center md:text-left">Testimonials</h2>
        <div className="flex justify-center max-md:hidden">
          <div className="inline-flex items-center bg-[#F6F6F6] py-3 px-6 rounded-full gap-2 text-gray-600">
            <span 
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: 'var(--primary-blue)' }}
            ></span>
            <span className="text-lg font-medium">Clients that trusted us</span>
          </div>
        </div>
      </div>

      {/* Testimonials Grid */}
      <div className="grid grid-cols-1 md:grid-cols-7 gap-4 md:gap-8 mb-12 max-md:px-2">
        {Array.isArray(testimonials) && testimonials.map((testimonial) => (
          <div 
            key={testimonial.id} 
            className="text-center px-6 py-10 bg-white rounded-2xl md:col-span-2"
            style={{ boxShadow: '0 0 12px 2px rgba(0, 0, 0, 0.1)' }}
          >
            {/* Profile Image */}
            <div className="mb-6">
              <div 
                className="w-28 h-28 mx-auto rounded-full overflow-hidden mb-4 p-[2px]"
                style={{ 
                  background: 'linear-gradient(45deg, var(--primary-blue) 0%, rgba(29, 66, 233, 0.36) 100%)'
                }}
              >
                <div className="w-full h-full rounded-full overflow-hidden bg-white">
                  <ServerImage 
                    src={testimonial.photo} 
                    alt={testimonial.client_name}
                    fallback="/testimonials/fathi.png"
                    className="w-full h-full p-1.5 object-cover"
                  />
                </div>
              </div>
              
              {/* Name and Title */}
              <h3 className="text-xl md:text-lg font-bold text-gray-900 md:mb-1">{testimonial.client_name}</h3>
              <p className="text-base md:text-sm text-gray-500 mb-4">
                {testimonial.title}
                {testimonial.company && ` - ${testimonial.company}`}
              </p>
            </div>

            

            {/* Testimonial Text */}
            <p className="text-gray-600 text-sm leading-relaxed">
              {testimonial.review}
            </p>
          </div>
        ))}
        
        {/* See All Button as 4th Grid Item */}
        <div 
          className="text-center p-4 flex items-center justify-center md:col-span-1"
          
        >
          <button 
            onClick={() => navigate('/about#testimonials')}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full hover:text-gray-800 transition-colors duration-200 group"
            style={{ boxShadow: '0 0 12px 2px rgba(0, 0, 0, 0.1)' }}
          >
            <span className="text-base md:text-base font-normal">See all</span>
            <FaArrowRight  />

          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;